import Draggable from 'react-draggable';
import styled from 'styled-components';
import { ReactNode } from 'react';

interface IZoomedInDraggableRobotWrapper {
  children: ReactNode;
  setIsDragging: (val: boolean) => void;
}

export const ZoomedInDraggableRobotWrapper = ({
  children,
  setIsDragging,
}: IZoomedInDraggableRobotWrapper) => {
  const handleOnDrag = () => {
    setIsDragging(true);
  };

  const handleOnStop = () => {
    // this makes sure that the onClick on the img is called before setting isDragging to false
    // this prevents the onClick on the image from being called when the dragging stops
    setTimeout(() => {
      setIsDragging(false);
    }, 0);
  };

  return (
    <Draggable
      axis="y"
      bounds={{ top: -350, bottom: 350 }}
      onDrag={handleOnDrag}
      onStop={handleOnStop}
    >
      <ZoomedInDraggableRobotWrapper.Wrapper>{children}</ZoomedInDraggableRobotWrapper.Wrapper>
    </Draggable>
  );
};

ZoomedInDraggableRobotWrapper.Wrapper = styled.div`
  height: 100%;
`;
